import React from 'react';

function Modal({ loading, cancelButtonText = 'Cancel', submitButtonText = 'Submit',id,saveAction,cancelAction, ...props }) {
  
    return (
        <div>
            <div className="modal fade" id={id} tabIndex={"hello"} role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog cascading-modal modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header light-blue darken-3 white-text">
                            <h4 className="title text-left h4"><i className={props.iconClass} /> {props.title}</h4>
                            <button type="button" className="close mr-0" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            {props.children}
                        </div>
                        <div className="modal-footer">

                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={cancelAction} >{cancelButtonText}</button>
                            <button type="submit" disabled={loading}  className="btn btn-primary" onClick={saveAction} >{loading ? "Please wait..." : submitButtonText}</button>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    );
}

export default Modal;